// extracted by mini-css-extract-plugin
module.exports = {"ovauta5":"ovauta5","w1hwfiwi":"w1hwfiwi"};